import type { ComponentProps, ReactNode } from "react";
import { spacing, type Gap } from "@web/theme/theme";

export type StackProps = {
  /** Gap from the 4-pt scale (1 = 4px … 8 = 32px). */
  gap?: Gap;
  align?: "stretch" | "start" | "center" | "end";
  as?: "div" | "section" | "form" | "ul" | "nav";
  /** Only meaningful with `as="form"`. */
  onSubmit?: ComponentProps<"form">["onSubmit"];
  className?: string;
  variant?: "default" | "thread-empty" | "upcoming-expansion";
  children: ReactNode;
};

const alignClass = { stretch: "items-stretch", start: "items-start", center: "items-center", end: "items-end" } as const;

/** Vertical layout primitive so screens never write spacing classes. */
export function Stack({ gap = 3, align = "stretch", as: Tag = "div", onSubmit, className = "", children, variant = "default" }: StackProps) {
  const variantClass = { default: "", "thread-empty": "v365-thread-empty", "upcoming-expansion": "v365-upcoming-expansion" }[variant];
  const classes = `flex flex-col ${spacing[gap]} ${alignClass[align]} ${variantClass} ${className}`.trim();
  if (Tag === "form") {
    return (
      <form onSubmit={onSubmit} className={classes}>
        {children}
      </form>
    );
  }
  return <Tag className={classes}>{children}</Tag>;
}
